import { render, staticRenderFns } from "./pace-logo.vue?vue&type=template&id=c8c94992&scoped=true&"
var script = {}
import style0 from "./pace-logo.vue?vue&type=style&index=0&id=c8c94992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c94992",
  null
  
)

export default component.exports